export var Plans;
(function (Plans) {
    Plans["TOTAL_LEASING"] = "Total Leasing";
    Plans["LEASING_3D"] = "3D Leasing";
    Plans["MARKETING_SUITE"] = "Marketing Suite";
})(Plans || (Plans = {}));
